import { useState, useEffect } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vs } from 'react-syntax-highlighter/dist/esm/styles/prism';
import  './index.scss';
const extMap = {
  js: 'javascript', jsx: 'jsx', ts: 'typescript', 
  html: 'html', css: 'css', scss: 'scss',
  py: 'python', java: 'java', go: 'go',
  json: 'json', xml: 'xml', sh: 'bash',
  md: 'markdown', txt: 'text'
};
const CodeFileViewer = ({ file, url,fileType }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // 获取文件内容
  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        
        if (file) {
          // 本地文件处理
          if (file.size > 1024 * 1024) throw new Error('文件超过1MB限制');
          const text = await file.text();
          setContent(text);
        } else if (url) {
          // 远程文件处理
          const response = await fetch(url);
          if (!response.ok) throw new Error('获取文件失败');
          const text = await response.text();
          setContent(text);
        }
        
      } catch (err) {
        console.log(err)
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (file || url) fetchContent();
  }, [file, url]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;
  
  return (
    <div className="code-preview">
      <SyntaxHighlighter
        language={extMap[fileType]}
        style={vs}
        showLineNumbers
        wrapLines
        lineProps={{ style: { padding: '2px 0' } }}
      >
        {content}
      </SyntaxHighlighter>
    </div>
  );
};

export default CodeFileViewer;